export { default } from './PaymentPaypal';
